import { setStorage } from 'utils/localstorage'
import { getStorage } from 'utils/localstorage'
import { get, post } from "utils/request"
import { OK } from "utils/constant"
import store from "store"
import { createAction, SET_GOODS, SET_PAYMENTS } from "store/ActionTypes"
import qs from "qs"
import { getStoredParams } from "utils/utils"

export async function $getGoods () {
  const goodsData = getStorage('goodsData')

  // 如果有缓存先使用缓存数据
  if (goodsData) {
    store.dispatch(createAction(SET_GOODS, goodsData.goods))
    store.dispatch(createAction(SET_PAYMENTS, goodsData.payments))
  }

  const options = {}

  const data = await get(`/store/goods`, options)
  if (data.status === OK) {
    data.data.goods = data.data.goods
      .map(d => ({
        ...d,
        regular_price: (d.regular_price / 100).toFixed(2),
        present_price: (d.present_price / 100).toFixed(2),
        regular_usd_price: (d.regular_usd_price / 100).toFixed(2),
        present_usd_price: (d.usd_price / 100).toFixed(2),
        regular_hkd_price: (d.regular_hkd_price / 100).toFixed(2),
        present_hkd_price: (d.hkd_price / 100).toFixed(2),
      }))
    // 缓存并且更新数据
    setStorage('goodsData', data.data)
    store.dispatch(createAction(SET_GOODS, data.data.goods))
    store.dispatch(createAction(SET_PAYMENTS, data.data.payments))
  }
  return data
}

export async function $getSubGoods () {
  const options = {}
  const data = await get(`/store/goods?type=subscription`, options)
  return data
}


export async function $submitOrders (good_id: number, pay_channel: string,coupon_code?: string) {
  const storedParams = getStoredParams()

  const options = {
    body: {
      good_id,
      pay_channel,
      host: window.location.host,
      coupon_code,
      ...storedParams
    }
  }

  return await post('/store/orders', options)
}

export async function $alipaySubscription (good_id: number, pay_channel: string) {
  const storedParams = getStoredParams()

  const options = {
    body: {
      good_id,
      pay_channel,
      host: window.location.host,
      ...storedParams
    }
  }

  return await post('/store/subscription/alipay', options)
}

export async function $orderStatus (order_no: string, payer_id?: string,coupon_code?: string) {
  const options = {}
  const query = qs.stringify({ order_no, payer_id })
  return await get(`/store/orders?${query}`, options)
}

export async function $alipaySubscriptionStatus (subscription_id: string, transaction_id: string) {
  const options = {}
  const query = qs.stringify({ subscription_id, transaction_id })
  return await get(`/store/subscription/alipay?${query}`, options)
}

export async function $paypalSubscription (good_id: number) {
  const storedParams = getStoredParams()

  const options = {
    body: {
      good_id,
      host: window.location.host,
      ...storedParams
    }
  }
  return await post('/store/subscription/paypal', options)
}
